
import { defineComponent, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { formatMinuteToTime } from '@/utils/format'
import { TaskTimeSetting } from '@/views/dashboard/_components/task-time/task-time.service'

export default defineComponent({
  props: {
    taskTime: {
      type: Array as PropType<TaskTimeSetting[]>,
      default: []
    },
    /** 频率，1-每日，2-每周，3-每月 */
    frequency: {
      type: Number as PropType<1|2|3>,
      default: 1
    }
  },

  setup (props, context) {
    const { t } = useI18n()
    function formatNumberToCn (num: number) {
      return [
        '',
        t('groupPolicySettings.schedWeekMon'),
        t('groupPolicySettings.schedWeekTue'),
        t('groupPolicySettings.schedWeekWed'),
        t('groupPolicySettings.schedWeekThu'),
        t('groupPolicySettings.schedWeekFri'),
        t('groupPolicySettings.schedWeekSat'),
        t('groupPolicySettings.schedWeekSun'),
      ][num]
    }

    return {
      formatMinuteToTime,
      formatNumberToCn,
    }
  }
})
